import styled from '@mui/material/styles/styled';
import Box from '@mui/material/Box';

export const Root = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  ...theme.scrollbars.default
}));